export default __webpack_public_path__ + "static/media/property_873.2a54bdb2.png";